/* CPAP Mask Sizing & Care — hub filtering + PDP sizing modal. Dependency-free classic script. */
(function () {
  function initHub(root) {
    if (root.dataset.mfsHubInit) return;
    root.dataset.mfsHubInit = '1';
    const cards = Array.from(root.querySelectorAll('[data-fam]'));
    const state = { brand: 'All', type: 'All', method: 'All', q: '' };
    const countEl = root.querySelector('[data-result-count]');
    const clearEl = root.querySelector('[data-clear]');

    function apply() {
      let n = 0;
      cards.forEach((c) => {
        const okB = state.brand === 'All' || c.dataset.brand === state.brand;
        const okT = state.type === 'All' || c.dataset.type === state.type;
        const okM = state.method === 'All' || c.dataset.method === state.method;
        const okQ = !state.q || c.dataset.search.indexOf(state.q) !== -1;
        const show = okB && okT && okM && okQ;
        c.classList.toggle('mfs-hidden', !show);
        if (show) n++;
      });
      if (countEl) countEl.textContent = n;
      const empty = root.querySelector('[data-empty]');
      if (empty) empty.classList.toggle('mfs-hidden', n !== 0);
      const grid = root.querySelector('[data-grid]');
      if (grid) grid.classList.toggle('mfs-hidden', n === 0);
      const dirty = state.brand !== 'All' || state.type !== 'All' || state.method !== 'All' || state.q;
      if (clearEl) clearEl.classList.toggle('mfs-hidden', !dirty);
    }
    root.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-filter]');
      if (chip) {
        const k = chip.dataset.filter, v = chip.dataset.value;
        state[k] = v;
        root.querySelectorAll(`[data-filter="${k}"]`).forEach((c) => c.classList.toggle('is-active', c === chip));
        apply();
        return;
      }
      if (e.target.closest('[data-clear]')) {
        state.brand = state.type = state.method = 'All'; state.q = '';
        root.querySelectorAll('[data-filter]').forEach((c) => c.classList.toggle('is-active', c.dataset.value === 'All'));
        const s = root.querySelector('[data-search]'); if (s) s.value = '';
        apply();
      }
    });
    const search = root.querySelector('[data-search]');
    if (search) search.addEventListener('input', () => { state.q = search.value.trim().toLowerCase(); apply(); });
    apply();
  }

  function initPdp(root) {
    if (root.dataset.mfsPdpInit) return;
    root.dataset.mfsPdpInit = '1';
    const modal = root.querySelector('[data-modal]');
    const open = () => { if (!modal) return; modal.classList.add('is-open'); document.body.classList.add('mfs-noscroll'); const f = modal.querySelector('.box'); if (f) f.focus(); };
    const close = () => { if (!modal) return; modal.classList.remove('is-open'); document.body.classList.remove('mfs-noscroll'); };
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-modal]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-close-modal]') || (modal && e.target === modal)) { close(); return; }
      const tab = e.target.closest('[data-tab]');
      if (tab && modal) {
        const id = tab.dataset.tab;
        modal.querySelectorAll('[data-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
        modal.querySelectorAll('[data-pane]').forEach((p) => p.classList.toggle('is-active', p.dataset.pane === id));
        return;
      }
      const pill = e.target.closest('[data-size]');
      if (pill) {
        root.querySelectorAll('[data-size]').forEach((p) => p.classList.toggle('is-sel', p === pill));
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) close(); });
  }

  function boot() {
    document.querySelectorAll('[data-mfs-hub]').forEach(initHub);
    document.querySelectorAll('[data-mfs-pdp]').forEach(initPdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
